import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import circle1 from '../../assets/images/roadmap/road1r.png';
import circle2 from '../../assets/images/roadmap/road2r.png';
import circle3 from '../../assets/images/roadmap/road3r.png';
import circle4 from '../../assets/images/roadmap/road4r.png';
import circle5 from '../../assets/images/roadmap/road5r.png';
import coming from '../../assets/images/roadmap/Roadcome.png';

import './road_styles/roadcoming.css';

export default function RoadComing() {
  return (
    <>
      <Container className='mt-5 mb-5 roadcoming'>
        <div className="roadcoming_head text-center mt-5 mb-5">
          <h3>COMING SOON</h3>
        </div>
        <Row className='flex-row'>
          <Col lg={6} className="roadcome_col">
                <div className="para_come ms-auto">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>
                <div className='row'>
                    <div className="para_come_img mb-5 d-flex justify-content-end">
                    <div className="text-right">
                     <img src={coming} alt="Circle towards right side" className='img-fluid' />  
                    </div>
                    </div>
                </div>

                <div className='row'>
                    <div className="para_come_img mb-5 d-flex justify-content-end">
                    <div className="text-right lft_img">
                  <img src={circle2} alt="Circle towards right side" className='roadcome_cir1' />
                  <span className='come_cir'>2021/10</span>  
                </div>
                    </div>
                </div>

                <div className="para_come ms-auto left3">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>
                <div className='row'>
                    <div className="para_come_img mb-5 d-flex justify-content-end">
                    <div className="text-right">
                  <img src={coming} alt="Circle towards right side" className='img-fluid' />  
                </div>
                    </div>
                </div>

                <div className='row'>
                    <div className="para_come_img mb-5 d-flex justify-content-end">
                    <div className="text-right lft_img">
                  <img src={circle4} alt="Circle towards right side" className='roadcome_cir1' />
                  <span className='come_cir'>2021/10</span>  
                </div>
                    </div>
                </div>

                <div className="para_come ms-auto left5">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>
                <div className='row'>
                    <div className="para_come_img mb-5 d-flex justify-content-end">
                    <div className="text-right">
                  <img src={coming} alt="Circle towards right side" className='img-fluid' />  
                </div>
                    </div>
                </div>                
          </Col>

          <Col lg={6} className='col_come_left roadcome_col'>
                <div className="para_come_img2 mb-5 d-flex justify-content-start">
                  <div className="rt_img">
                   <img src={circle1} alt="Circle towards right side" />
                   <span>2021/10</span>
                  </div>  
                </div>

                <div className="para_come me-auto right2">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>
                <div className="para_come_img2 mb-5 d-flex justify-content-start">
                  <img src={coming} alt="Circle towards right side" className='img-fluid' />  
                </div>

                <div className="para_come_img2 mb-5 d-flex justify-content-start mt-5">
                  <div className="rt_img">
                   <img src={circle3} alt="Circle towards right side" />
                   <span>2021/10</span>
                  </div>  
                </div>

                <div className="para_come me-auto right2">
                  <span>
                    The Virtual Exchange project was confirmed, and the official website was
                    launched on July 29, announcing the development of the Virtual Exchange plan.  
                  </span>  
                </div>
                <div className="para_come_img2 mb-5 d-flex justify-content-start">
                  <img src={coming} alt="Circle towards right side" className='img-fluid' />  
                </div>

                <div className="para_come_img2 mb-5 d-flex justify-content-start mt-5">
                  <div className="rt_img">
                   <img src={circle5} alt="Circle towards right side" />
                   <span>2021/10</span>
                  </div>  
                </div>
          </Col>  
        </Row>
      </Container>
    </>
  )
}
